import Enum from "../../../../../../enums/Enum";

const AmbulatoryAidEnum = new Enum({
        NONE_BEDREST_NURSEASSIST: {name: "None/ Bed Rest/ Nurse Assist"},
        CRUTCHES_CANE_WALKER: {name: "Crutches / Cane / Walker"},
        FURNITURE: {name: "Furniture"}
});

export default AmbulatoryAidEnum;